import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name (the field has no visible label). */
  label: string;
  width?: number;
}

/** Search box with a leading search icon, sized for a card filter bar. */
export function SearchField({
  value,
  onChange,
  placeholder,
  label,
  width = 360,
}: SearchFieldProps) {
  return (
    <TextField
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      inputProps={{ "aria-label": label }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
          </InputAdornment>
        ),
      }}
      sx={{ width: { xs: "100%", sm: width }, maxWidth: "100%" }}
    />
  );
}

export default SearchField;
